import React, { useState } from 'react';
import './TransferCertificate.css';

const TransferCertificate = () => {
  const [selectedYear, setSelectedYear] = useState('');
  const [showTable, setShowTable] = useState(false);

  const students2024 = [
    { id: 1, scholarNo: 8111, name: 'MOHAMMD', father: 'HAIDER', pdfFile: '/MOHAMMD_TC.pdf' },
    { id: 2, scholarNo: 8977, name: 'VEYDANT SINGH', father: 'RIPUDAMAN', pdfFile: '/veydant singh.pdf' },
    { id: 3, scholarNo: 7821, name: 'DRISHTY YADAV', father: 'SATISH YADAV', pdfFile: '/drishty yadav.pdf' },
    { id: 4, scholarNo: 6280, name: 'ADITI SWAMI', father: 'DINESH SWAMI', pdfFile: '/aditi swami.pdf' },
    { id: 5, scholarNo: 7543, name: 'SUHANI', father: 'RANVEER BISHNOI', pdfFile: '/suhani.pdf' },
    { id: 6, scholarNo: 8965, name: 'LAKSHAYA', father: 'INDERSEN', pdfFile: '/lakshaya.pdf' },
    { id: 7, scholarNo: 8928, name: 'DANISH SINGH BRAR', father: 'GAGANDEEP SINGH', pdfFile: '/danish singh brar.pdf' },
    { id: 8, scholarNo: 8533, name: 'YUVRAJ', father: 'ROHIT KUMAR', pdfFile: '/yuvraj.pdf' },
    { id: 9, scholarNo: 5974, name: 'VANSH MOYAL', father: 'VIRENDER MOYAL', pdfFile: '/vansh moyal.pdf' },
    { id: 10, scholarNo: 8579, name: 'HARDEV SINGH', father: 'PARVINDER SINGH', pdfFile: '/hardev singh.pdf' },
    { id: 11, scholarNo: 8631, name: 'JASHAN SINGH', father: 'GURBAKSH SINGH', pdfFile: '/jashan singh.pdf' }
  ];

  const students2025 = [
    { id: 1, scholarNo: 9257, name: 'CHAITANYA OJHA', father: 'LOKESH OJHA', pdfFile: '/chaitanya ojha 2026.pdf' },
    { id: 2, scholarNo: 8418, name: 'SAHAJ SHARMA', father: 'YATESH SHARMA', pdfFile: '/sahaj sharma 2026.pdf' },
    { id: 3, scholarNo: 8956, name: 'HARDIK BISHNOI', father: 'VINOD KUMAR', pdfFile: '/hardik bishnoi 2026.pdf' },
    { id: 4, scholarNo: 9235, name: 'KARTIK JANGIR', father: 'RAJESH KUMAR JANGIR', pdfFile: '/kartik jangir 2026.pdf' },
    { id: 5, scholarNo: 8954, name: 'HIMANSHI SINGHAL', father: 'GAJENDER SINGHAL', pdfFile: '/himanshi singhal.pdf' },
    { id: 6, scholarNo: 8237, name: 'KARANBEER KATARIA', father: 'NEERAJ KATARIA', pdfFile: '/karanbeer kataria 2026.pdf' },    
    { id: 7, scholarNo: 9303, name: 'TANISHKA AGARWAL', father: 'VIKAS AGARWAL', pdfFile: '/tanishka agarwal 2026.pdf' },
    { id: 8, scholarNo: 6385, name: 'MAULIK ARORA', father: 'AMIT ARORA', pdfFile: '/maulik arora 2026.pdf' },
    { id: 9, scholarNo: 9450, name: 'VISHAL', father: 'DHARMENDER SHARMA', pdfFile: '/vishal 2026.pdf' },
    { id: 10, scholarNo: 9250, name: 'NITIN KUMAR', father: 'SUNIL KUMAR', pdfFile: '/nitin kumar 2026.pdf' },
  ];


  const getStudentsByYear = () => {
    if (selectedYear === '2024-2025') {
      return students2024;
    } else if (selectedYear === '2025-2026') {
      return students2025;
    }
    return [];
  };

  const handleShow = () => {
    if (selectedYear) {
      setShowTable(true);
    } else {
      alert('Please select a year');
    }
  };

  const handleDownload = (student) => {
    const pdfPath = `/tc/${student.pdfFile}`;
    window.open(pdfPath, '_blank');
  };

  const currentStudents = getStudentsByYear();

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>TRANSFER CERTIFICATE</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Transfer Certificate</li>
          </ul>
        </div>
      </section>

      <div className="tc-container">
        <div className="tc-header">
          <div className="tc-title-section">
            <div className="tc-line"></div>
            <h1>TRANSFER CERTIFICATE</h1>
          </div>

          <div className="tc-filter-section">
            <select 
              value={selectedYear} 
              onChange={(e) => setSelectedYear(e.target.value)}
              className="tc-select"
            >
              <option value="">Select Year</option>
              <option value="2024-2025">2024-2025</option>
              <option value="2025-2026">2025-2026</option>
            </select>

            <button className="tc-show-btn" onClick={handleShow}>
              SHOW
            </button>
          </div>
        </div>

        {showTable && (
          <div className="tc-table-wrapper">
            <table className="tc-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Scholar No</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>Transfer Certificate</th>
                </tr>
              </thead>
              <tbody>
                {currentStudents.map((student) => (
                  <tr key={student.id}>
                    <td>{student.id}</td>
                    <td>{student.scholarNo}</td>
                    <td>{student.name}</td>
                    <td>{student.father}</td>
                    <td>
                      <button 
                        className="tc-download-btn"
                        onClick={() => handleDownload(student)}
                      >
                        Download
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default TransferCertificate;